import { Directive, Input, EventEmitter, Output, ElementRef, HostListener } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[scrollspy]'
})
export class ScrollSpyDirective {
    private currentSection: string;

    @Input() spiedtags = [];
    @Output() sectionChange = new EventEmitter<string>();
    
    @HostListener('scroll', ['$event']) onScroll(event) {
        let currentSection: string;
        const children = this._el.nativeElement.children;
        const scrollTop = event.target.scrollTop;
        const parentOffset = event.target.offsetTop;
        for (let i = 0; i < children.length; i++) {
            const element = children[i];
            if (this.spiedtags.some(spiedTag => spiedTag === element.tagName)) {
                if ((element.offsetTop - parentOffset) <= scrollTop) {
                    currentSection = element.id;
                }
            }
        }
        if (currentSection !== this.currentSection) {
            this.currentSection = currentSection;
            this.sectionChange.emit(this.currentSection);
        }
    }

    constructor(private _el: ElementRef) {
    }
}